
<div class="modal-dialog">
  <div class="modal-content">
    <div class="modal-header text-center d-block">
      <h4 class="text-primary mb-0">Choose a Category</h4>
      <!-- <button type="button" (click)="close()"  class="close-modal"> 
        <i class="icon-cross-small"></i>
        </button>  -->
    </div>
    <div class="modal-body">
  
      <div class="category">
        <ul class="p-0">
          <li class="categorylist mb-3 " *ngFor="let item of category; index as i" [value]="item.form_id"
            (click)="onCategoryClick(item)" [class.active]="selectedCategoryIndex === item.id">{{item.request ?? item.name}}
          </li>
  
        </ul>
      </div>
      <div class="_footer mt-auto justify-content-center text-center">
  
        <button type="button" class="btn btn-outline-primary mx-2" (click)="back()">
          Back
        </button>
        <button type="button" (click)="createUniverslForm()" [disabled]="selectedCategoryIndex===null "
          class="btn btn-primary mx-2">
          Next
        </button>
      </div>
    </div>
  
  </div>
</div>